"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "venzone": {
    "adfdb948": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "bidernuccio-borg": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4b0502ef": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "cantiere-cantir": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2b13e778": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "chiavris-ciavis": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1e6ec157": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "di-sotto-di-sot": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05a7f7c7": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "gnocs": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "914a421b": [{
      "hkey": "984caca2",
      "slug": "pioverno",
      "name": "Pioverno",
      "primary": true,
      "skipSearch": false
    }],
    "localita-pioverno-pluver": [{
      "hkey": "984caca2",
      "slug": "pioverno",
      "name": "Pioverno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "678f15ff": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "lugan": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1fa54bd8": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "marsuris": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa495889": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "mastrui-santa-caterina-sot-vencon": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa8f1291": [{
      "hkey": "095c8630",
      "slug": "nuova-portis",
      "name": "Nuova Portis",
      "primary": true,
      "skipSearch": false
    }],
    "portis-puartis": [{
      "hkey": "095c8630",
      "slug": "nuova-portis",
      "name": "Nuova Portis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a6f1032c": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "rozza-roce": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8fb74f4c": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "san-giacomo-san-jacun": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "23d48ff6": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "skipSearch": false
    }],
    "sottomonte-samonc": [{
      "hkey": "a7a9305d",
      "slug": "venzone",
      "name": "Venzone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;